import { render, staticRenderFns } from "./PendingAuditApplyForIndex.vue?vue&type=template&id=958c470c&scoped=true"
import script from "./PendingAuditApplyForIndex.vue?vue&type=script&lang=js"
export * from "./PendingAuditApplyForIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958c470c",
  null
  
)

export default component.exports